import { Component, Input, Output, EventEmitter } from "@angular/core";
import { MessagePageAction } from "./message-page-layout.models";
import { UtilityService } from "../../services/utility.service";

@Component({
    selector: "dodo-message-page-layout",
    templateUrl: "./message-page-layout.component.html",
    styleUrls: ["./message-page-layout.component.scss"],
    standalone: false
})
export class MessagePageLayoutComponent {
	// Public Variables
	public _busy = false;
	public isMobile = false;
	// Input Variables
	@Input() title: string;
	@Input() image: string;
	@Input() msg: string;
	@Input() finePrints: string;
	@Input() actions: MessagePageAction[];
	@Input() width = 500;
	@Input() errorCode: string = null;
	@Input() disabled: boolean;
	@Input() loadingFeature: boolean;
	// Output Variables
	@Output() actionClicked = new EventEmitter<string>();

	// Constructor
	constructor(utility: UtilityService) {
		this.isMobile = utility.isMobile;
	}

	// Button Listener
	_buttonClicked(actionId: string) {
		if (this._busy) {
			return;
		}
		if (this.loadingFeature) {
			this._busy = true;
		}
		this.actionClicked.emit(actionId);
	}
}
